import { SMH } from '@/renderer/scripts/smh';
type Organizations = SMH.OrgItem[];

export type UserRole = 'unknown' | 'User' | 'Admin' | 'SuperAdmin' | string;

// 登录方式，待补充企微、app扫码
export enum LoginTypeKey {
  loginWithAppCode = 'loginWithAppCode',
  loginWithPhone = 'loginWithPhone',
  loginWithPassword = 'loginWithPassword',
  loginWithWechat = 'loginWithWechat',
  loginWithWecom = 'loginWithWecom',
  loginWithCookie = 'loginWithCookie',
  loginWithMeeting = 'loginWithMeeting', // 会议里授权自动登录
  loginWithYufu = 'loginWithYufu', // yufu
  loginWithSSO = 'loginWithSSO',
  loginWithLDAP = 'loginWithLDAP',
  loginWithMeetingPhone = 'loginWithMeetingPhone', // 会议里自动获取手机号并登录
  loginWithJAccount = 'loginWithJAccount', // 交大jAccount登录
  loginWithIOA = 'loginWithIOA', // 腾讯IOA登录
}

export type LoginMainEntrance =
  | LoginTypeKey.loginWithPhone
  | LoginTypeKey.loginWithWechat
  | LoginTypeKey.loginWithPassword
  | LoginTypeKey.loginWithJAccount
  | LoginTypeKey.loginWithIOA;

export type LoginMoreEntrance =
  | LoginTypeKey.loginWithWecom
  | LoginTypeKey.loginWithYufu
  | LoginTypeKey.loginWithSSO
  | LoginTypeKey.loginWithLDAP;

// 记录当前登录使用的方式 即使cookie恢复登录态也能标记初识登录方式
export type CurrentLoginedType =
  | LoginTypeKey.loginWithAppCode
  | LoginTypeKey.loginWithPhone
  | LoginTypeKey.loginWithPassword
  | LoginTypeKey.loginWithWechat
  | LoginTypeKey.loginWithWecom
  | LoginTypeKey.loginWithYufu
  | LoginTypeKey.loginWithSSO
  | LoginTypeKey.loginWithLDAP
  | LoginTypeKey.loginWithMeeting
  | LoginTypeKey.loginWithMeetingPhone
  | LoginTypeKey.loginWithJAccount
  | LoginTypeKey.loginWithIOA
  | string;

type LoginType = CurrentLoginedType | 'loginWithCookie';

// 登录动作
export enum LoginActionKey {
  login = 'login',
  bindPhone = 'bindPhone',
}

// 登录后执行动作，默认无动作
export enum LoginFuncKey {
  loginToJoin = 'loginToJoin',
}

// 登录过程需要绑定手机号,对应的绑定业务
export enum LoginBindTypeKey {
  bindPhoneInMeeting = 'bindPhoneInMeeting',
  bindPhoneInWeChat = 'bindPhoneInWeChat',
  bindPhoneInWeCom = 'bindPhoneInWeCom',
  bindPhoneInYufu = 'bindPhoneInYufu', // yufu
  bindPhoneInSSO = 'bindPhoneInSSO', // sso
  bindPhoneInLDAP = 'bindPhoneInLDAP', // ldap/ad
}

export type LoginFrom = 'web' | 'pc' | string;

type LoginAction = 'login' | 'bindPhone' | string;

export type TenantType = 'tenantName' | 'domain' | string;

export type WecomParams = {
  corpid: string;
  domain: string;
};

export type LdapAccount = {
  ldapType: 'openLdap' | 'windowsAd' | string;
  accountName: string;
  accountPassword: string;
};

export type SSOAccount = {
  // credential在cas协议传ticket（无code），oauth/oidc传code
  credential?: string;
};

export type BaseInfo = {
  userId?: number;
  isNewUser?: 'unknown' | 'no' | 'yes' | string;
  isOrgNewUser?: 'unknown' | 'no' | 'yes' | string;
  userRole?: UserRole;
  userToken?: string;
  organizations?: Organizations;
  isLogined?: boolean;
  hasAppliedChannelOrg?: boolean;
  needChangePassword?: boolean;
  currentLoginedType?: CurrentLoginedType;
};

export type LoginInfo = {
  loginType?: LoginType;
  loginAction?: LoginAction;
  loginFunc?: LoginFuncKey | string;
  loginBindType?: LoginBindTypeKey | string;
  tenantKey?: string;
  tenantType?: TenantType;
  loginFrom?: LoginFrom;
  authCode?: string;
  invitationCode?: string;
  remember?: boolean;
  phoneNumber?: string;
  countryCode?: string;
  wecomParams?: WecomParams;
  canAutoLoginOrg?: boolean;
  cannotSelectOrg?: boolean;
  corpid?: string;
  ssoFrom?: 'web' | 'pc' | string;
  ssoAccount?: SSOAccount;
  ldapAccount?: LdapAccount;
};

export type OrgInfo = {
  organizationId?: number;
  multiOrg?: boolean;
  libraryId?: string;
  expired?: boolean;
  editionFlag?: string;
  editionConfig?: any;
  orgChannel?: string;
  channelUpdated?: boolean;
};

export type UserInfo = {
  baseInfo: BaseInfo;
  loginInfo: LoginInfo;
  orgInfo: OrgInfo;
};

export type FlatUserInfo = BaseInfo &
  LoginInfo &
  OrgInfo & {
    [key: string]: any;
  };
